import { Action, on } from "@ngrx/store";
import { JobseekerApplicationState } from "./state";
import * as Actions from './actions';
import { createImmerReducer } from "ngrx-immer/store";
import { JobseekerInviteFilterEnum } from "src/app/jobseeker/shared/models/enums/invite-list-filter-enum";
import { AnnouncementInviteViewStatusEnum } from "@hrra/common-models";

let initialState: JobseekerApplicationState = {
    vacancyApplications: {
        applicationModel: null,
        loading: null,
        isActiveTab: null,

        pageState: {
            pageLinkCount: 5,
            currentPage: 1,
        },
    },

    cvBoxApplications:{
        applicationModel: null,
        loading: null,
        isActiveTab: null,

        pageState: {
            pageLinkCount: 5,
            currentPage: 1,
        },
    },

    invites: {
        items: null,
        stats: null,
        loading: null,
        filter: JobseekerInviteFilterEnum.All,

        pageState: {
            pageLinkCount: 5,
            currentPage: 1,
        },
    },

    inviteDetails: {
        announcement: null,
        loading: null,
        responding: null,
        responseStatus: null,
        announcementInvitedJobseeker: null,
        isJobseekerInvited: null,
        announcementFailureDetails: null,
        metaData: null,
    }
}

const reducer = createImmerReducer(
    initialState,

    on(Actions.loadApplications, (state, { payload }) => {
        state.vacancyApplications.loading = true;
        return state;
    }),
    on(Actions.loadApplicationsSuccess, (state, { payload }) => {
        state.vacancyApplications.applicationModel = payload.application;
        state.vacancyApplications.pageState.currentPage = payload.page;
        state.vacancyApplications.loading = false;
        return state;
    }),
    on(Actions.loadApplicationsFail, (state, { payload }) => {
        state.vacancyApplications.loading = false;
        return state;
    }),
    on(Actions.loadCvBoxApplications, (state, { payload }) => {
        state.cvBoxApplications.loading = true;
        return state;
    }),
    on(Actions.loadCvBoxApplicationsSuccess, (state, { payload }) => {
        state.cvBoxApplications.applicationModel = payload.application;
        state.cvBoxApplications.pageState.currentPage = payload.page;
        state.cvBoxApplications.loading = false;
        return state;
    }),
    on(Actions.loadCvBoxApplicationsFail, (state, { payload }) => {
        state.cvBoxApplications.loading = false;
        return state;
    }),

    on(Actions.loadInvites, (state, { payload }) => {
        if (state.invites.filter !== payload.filter) {
            state.invites.items = [];
            state.invites.pageState.currentPage = 1;
        }
        state.invites.filter = payload.filter;
        state.invites.loading = true;
        return state;
    }),
    on(Actions.loadInvitesSuccess, (state, { payload }) => {
        state.invites.items = payload.jobseekerInviteResponse.data;
        state.invites.stats = payload.jobseekerInviteResponse.stats;
        state.invites.pageState.currentPage = payload.page;
        state.invites.loading = false;
        return state;
    }),
    on(Actions.loadInvitesFail, (state, { payload }) => {
        state.invites.loading = false;
        return state;
    }),

    on(Actions.loadInviteAnnouncement, (state, { payload }) => {
        state.inviteDetails.announcement = null;
        state.inviteDetails.responseStatus = null;
        state.inviteDetails.announcementInvitedJobseeker = null;
        state.inviteDetails.isJobseekerInvited = null;
        state.inviteDetails.announcementFailureDetails = null;
        state.inviteDetails.metaData = null;
        state.inviteDetails.loading = true;
        return state;
    }),
    on(Actions.loadInviteAnnouncementSuccess, (state, { payload }) => {
        state.inviteDetails.announcement = payload.announcementDetails.announcement;
        state.inviteDetails.announcementInvitedJobseeker = payload.announcementDetails.announcementInvitedJobseeker;
        state.inviteDetails.isJobseekerInvited = payload.announcementDetails.isJobseekerInvited;
        state.inviteDetails.metaData = payload.announcementDetails.metaData;
        state.inviteDetails.loading = false;
        return state;
    }),
    on(Actions.loadInviteAnnouncementFail, (state, { payload }) => {
        state.inviteDetails.announcementFailureDetails = payload;
        state.inviteDetails.loading = false;
        return state;
    }),

    on(Actions.markInviteViewedSuccess, (state, { payload }) => {
        let invite = state.invites.items?.find(i => i.inviteId === payload.inviteId);
        if (invite != null) {
            invite.viewStatus = AnnouncementInviteViewStatusEnum.Seen;
        }
        return state;
    }),

    on(Actions.respondToInvite, (state, { payload }) => {
        state.inviteDetails.responding = true;
        return state;
    }),
    on(Actions.respondToInviteSuccess, (state, { payload }) => {
        state.inviteDetails.responding = false;
        state.inviteDetails.responseStatus = payload.responseStatus;

        if (state.inviteDetails.announcementInvitedJobseeker?.announcementInvitedJobseekerId === payload.inviteId) {
            state.inviteDetails.announcementInvitedJobseeker.responseStatus = payload.responseStatus;
        }

        let invite = state.invites.items?.find(i => i.inviteId === payload.inviteId);
        if (invite != null) {
            invite.responseStatus = payload.responseStatus;
        }
        return state;
    }),
    on(Actions.respondToInviteFail, (state, { payload }) => {
        state.inviteDetails.responding = false;
        return state;
    })
)

export function jobseekerApplicationsReducer(state: JobseekerApplicationState | undefined, action: Action) {
    return reducer(state, action);
}